<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        รายงานอัตราค่าบริการเฉลี่ยของบริการอินเทอร์เน็ตความเร็วสูงประจำที่
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <!-- <i class="fa fa-dashboard"></i> รายงานจำนวนรายการส่งเสริมการขายบริการโทรศัพท์เคลื่อนที่จำแนกตามประเภทบริการ -->
          </a>
        </li>
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-primary">
              <div class="box-header">
                <div class="layout_filter_search">
                  <h2>ตัวเลือกการค้นหา</h2>
                  <div class="row">
                    <el-form
                      size="mini"
                      :label-position="label_position"
                      label-width="150px"
                      :model="form"
                      ref="ruleForm"
                      class="demo-ruleForm"
                    >
                      <div class="col-sm-12">
                        <div class="col-sm-6">
                          <el-form-item label="ประเภทรายงาน" required>
                            <el-select
                              ref="type_report"
                              v-model="form.type_report"
                              @change="clear_data"
                            >
                              <el-option label="ระหว่างเดือน" value="between_month"></el-option>
                              <el-option label="รายปี" value="year"></el-option>
                              <el-option label="ระหว่างปี" value="between_year"></el-option>
                              <el-option label="ไตรมาส" value="quarter"></el-option>
                              <el-option label="ช่วงไตรมาส" value="between_quarter"></el-option>
                            </el-select>
                          </el-form-item>
                        </div>
                        <div class="col-sm-6">
                          <el-form-item
                            label="กรุณาเลือกประเภทรายงาน"
                            v-if="form.type_report === ''"
                          >
                            <el-input disabled placeholder></el-input>
                          </el-form-item>
                          <el-form-item
                            label="ช่วงเวลา"
                            v-bind:class="[form.type_report === 'month' ?  '': 'not_display']"
                            required
                          >
                            <el-date-picker
                              ref="month"
                              v-model="form.type_data.month"
                              style="width:100%;"
                              type="month"
                              clearable
                            ></el-date-picker>
                          </el-form-item>
                          <el-form-item
                            label="ช่วงเวลา"
                            v-bind:class="[form.type_report === 'between_month' ?  '': 'not_display']"
                            required
                          >
                            <el-date-picker
                              ref="monthfrom"
                              v-model="form.type_data.monthfrom"
                              style="width:40%;"
                              type="month"
                              clearable
                            ></el-date-picker>&nbsp;-&nbsp;
                            <el-date-picker
                              ref="monthto"
                              v-model="form.type_data.monthto"
                              style="width:40%;"
                              type="month"
                              clearable
                            ></el-date-picker>
                          </el-form-item>
                          <el-form-item
                            label="ช่วงเวลา"
                            v-bind:class="[form.type_report === 'year' ?  '': 'not_display']"
                            required
                          >
                            <el-date-picker
                              ref="year"
                              v-model="form.type_data.year"
                              style="width:100%;"
                              type="year"
                              clearable
                            ></el-date-picker>
                          </el-form-item>
                          <el-form-item
                            label="ช่วงเวลา"
                            v-bind:class="[form.type_report === 'between_year' ?  '': 'not_display']"
                            required
                          >
                            <el-date-picker
                              ref="yearfrom"
                              v-model="form.type_data.yearfrom"
                              type="year"
                            ></el-date-picker>&nbsp;&nbsp;-&nbsp;
                            <el-date-picker
                              ref="yearto"
                              v-model="form.type_data.yearto"
                              type="year"
                            ></el-date-picker>
                          </el-form-item>
                          <el-form-item
                            label="ช่วงเวลา"
                            v-bind:class="[form.type_report === 'quarter' ?  '': 'not_display']"
                            required
                          >
                            <el-select
                              style="width:50%;"
                              ref="quarter"
                              v-model="form.type_data.quarter"
                            >
                              <el-option label="1" value="1"></el-option>
                              <el-option label="2" value="2"></el-option>
                              <el-option label="3" value="3"></el-option>
                              <el-option label="4" value="4"></el-option>
                            </el-select>&nbsp;
                            <el-date-picker
                              v-model="form.type_data.quarter_year"
                              ref="quarter_year"
                              type="year"
                            ></el-date-picker>
                          </el-form-item>
                          <el-form-item
                            label="ช่วงเวลา"
                            v-if="form.type_report === 'between_quarter'"
                            v-bind:class="[form.type_report === 'between_quarter' ?  '': 'not_display']"
                            required
                          >
                            <el-select
                              style="width:20%;"
                              ref="quarterfrom"
                              v-model="form.type_data.quarterfrom"
                            >
                              <el-option label="1" value="1"></el-option>
                              <el-option label="2" value="2"></el-option>
                              <el-option label="3" value="3"></el-option>
                              <el-option label="4" value="4"></el-option>
                            </el-select>&nbsp;
                            <el-date-picker
                              style="width:25%;"
                              v-model="form.type_data.quarter_year_from"
                              ref="quarter_year"
                              type="year"
                            ></el-date-picker>&nbsp;&nbsp;&nbsp;-&nbsp;
                            <el-select
                              style="width:20%;"
                              ref="quarterto"
                              v-model="form.type_data.quarterto"
                            >
                              <el-option label="1" value="1"></el-option>
                              <el-option label="2" value="2"></el-option>
                              <el-option label="3" value="3"></el-option>
                              <el-option label="4" value="4"></el-option>
                            </el-select>&nbsp;
                            <el-date-picker
                              style="width:25%;"
                              v-model="form.type_data.quarter_year"
                              ref="quarter_year"
                              type="year"
                            ></el-date-picker>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="col-sm-12">
                        <div class="col-sm-6">
                          <!-- <div class="col-sm-12">
                            <el-form-item label="ประเภทผู้ให้บริการ">
                              <el-radio-group v-model="form.compare_type" @change="compareType">
                                <el-radio label="group">กลุ่มผู้ให้บริการ</el-radio>
                                <el-radio label="provider">รายชื่อผู้ให้บริการ</el-radio>
                              </el-radio-group>
                            </el-form-item>
                          </div>
                          <div class="col-sm-12">
                            <el-form-item label="กลุ่มผู้ให้บริการ" >
                              <el-checkbox-group v-model="form.provider_group" :disabled="this.form.compare_type !== 'group'">
                                <el-checkbox 
                                  ref="provider_group"
                                  v-for="group in this.store_groups" 
                                  :key="group.id" 
                                  :label="group.id"
                                  @change="pickGroup(group.group_company_list)">
                                  {{group.group_name_th}}
                                </el-checkbox>
                              </el-checkbox-group>
                            </el-form-item>
                          </div> -->
                          <div class="col-sm-12">
                            <el-form-item label="รายชื่อผู้ให้บริการ">
                              <el-checkbox-group v-model="form.provider_list" :disabled="this.form.compare_type !== 'provider'">
                                <el-checkbox 
                                ref="provider_list"
                                  v-for="provider in this.store_providers" 
                                  :key="provider.id" 
                                  :label="provider.id"
                                  @change="pickGroup(provider.id)">
                                  {{provider.brand_name}}
                                </el-checkbox>
                              </el-checkbox-group>
                            </el-form-item>
                          </div>
                        </div>
                          <div class="col-sm-6">
                            <el-form-item label="ประเภทเทคโนโลยี">
                              <el-select v-model="form.promotion_technology">
                                <el-option label="ทั้งหมด" value=""></el-option>
                                <el-option label="FTTx" value="FTTx"></el-option>
                                <el-option label="ADSL" value="ADSL"></el-option>
                                <el-option label="VDSL" value="VDSL"></el-option>
                                <el-option label="WiFi" value="WiFi"></el-option>
                                <el-option label="VAS" value="VAS"></el-option>
                              </el-select>
                            </el-form-item>
                          </div>
                          <div class="col-sm-6">
                            <el-form-item label="หน่วยนับอัตราค่าบริการ">
                              <el-radio-group v-model="form.service_rate">
                                <el-radio :label="'Kbps'">หน่วย: บาท/Kbps</el-radio>
                                <el-radio :label="'Mbps'">หน่วย: บาท/Mbps</el-radio>
                              </el-radio-group>
                            </el-form-item>
                          </div>
                          <div class="col-sm-6">
                            <el-form-item label="แสดงแนวโน้มอัตราค่าบริการในอนาคต">
                              <el-radio-group v-model="form.forecast">
                                <el-radio :label="1">แสดง</el-radio>
                                <el-radio :label="0">ไม่แสดง</el-radio>
                              </el-radio-group>
                            </el-form-item>
                          </div>
                          <div class="col-sm-6">
                            <el-form-item label="แสดงค่าบริการเฉลี่ย">
                              <el-radio-group v-model="form.average">
                                <el-radio :label="true">แสดง</el-radio>
                                <el-radio :label="false">ไม่แสดง</el-radio>
                              </el-radio-group>
                            </el-form-item>
                          </div>
                          <div class="col-sm-6">
                            <el-form-item label="วิธีการคำนวณค่าบริการเฉลี่ย">
                              <el-radio-group v-model="form.weighting" :disabled="form.average == false">
                                <el-radio :label="1">ถ่วงน้ำหนักจำนวนรายการส่งเสริมการขาย</el-radio>
                                <el-radio :label="0">ไม่ถ่วงน้ำหนักจำนวนรายการส่งเสริมการขาย</el-radio>
                              </el-radio-group>
                            </el-form-item>
                          </div>
                          <div class="col-sm-6">
                              <el-form-item label="สถานะการให้บริการ">
                                <el-checkbox-group v-model="form.service_status">
                                    <el-checkbox label="S">ประเภทบุคคลทั่วไป (รายการส่งเสริมการขายที่ยังขายอยู่)</el-checkbox><br/>
                                    <el-checkbox label="U">ประเภทบุคคลทั่วไป (รายการส่งเสริมการขายที่ไม่ขายแล้ว แต่ยังให้บริการอยู่)</el-checkbox><br/>
                                    <el-checkbox label="CS">ประเภทองค์กร (รายการส่งเสริมการขายที่ยังขายอยู่)</el-checkbox><br/>
                                    <el-checkbox label="CU">ประเภทองค์กร (รายการส่งเสริมการขายที่ไม่ขายแล้ว แต่ยังให้บริการอยู่)</el-checkbox><br/>
                                </el-checkbox-group>
                              </el-form-item>
                            </div>
                      </div>
                      <div class="layout_filter_btn">
                        <button type="button" class="btn btn-primary" @click="find_chart()">ค้นหา</button>
                      </div>
                    </el-form>
                  </div>
                  <div v-if="display_chart">
                    <div class="col-sm-12" style="text-align:right;">
                      <el-dropdown @command="exportFile" v-loading="pending">
                        <span class="btn btn-primary" >Export<i class="el-icon-arrow-down el-icon--right"></i></span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item icon="el-icon-download" command="pdf">Export PDF</el-dropdown-item>
                          <el-dropdown-item icon="el-icon-download" command="doc">Export DOC</el-dropdown-item>
                          <el-dropdown-item icon="el-icon-download" command="image">Export Image</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  </div>
                  <div id="chart" class="box-body" ref="chart">
                    <div v-if="display_chart">
                      <charts class="chart" :options="this.store_chart" v-if="display_chart" style="max-height : 400px; align: center;"></charts>
                      <div class="data-table" v-for="index in Math.ceil(this.store_chart.xAxis.categories.length/12)" :key="index">
                        <table>
                          <tr style="border-color: white;">
                            <th>ช่วงเวลา</th>
                            <template v-for="item in 12">
                              <th :key="item" v-if="((index-1)*12)+(item-1) < store_chart.xAxis.categories.length">{{ store_chart.xAxis.categories[((index-1)*12)+(item-1)] }}</th>
                              <!-- <th :key="item" v-else style="border-right-style: hidden; border-top-style: hidden; border-bottom-style: hidden; border-color: white;"></th> -->
                              <th :key="item" v-else-if="12 < store_chart.xAxis.categories.length" style="border-right-style: hidden; border-top-style: hidden; border-bottom-style: hidden; border-color: white;"></th>
                            </template>
                          </tr>
                          <tr v-for="provider in store_chart.series" :key="provider.name" style="border-color: white;">
                            <th>{{ provider.name }}</th>
                            <template v-for="data in 12">
                              <th :key="data" v-if="((index-1)*12)+(data-1) < provider.data.length" >{{ provider.data[((index-1)*12)+(data-1)] > 0 ? roundToTwo(provider.data[((index-1)*12)+(data-1)],store_chart.decimal).toFixed(store_chart.decimal) : '' }}</th>
                              <!-- <th :key="data" v-else style="border-right-style: hidden; border-top-style: hidden; border-bottom-style: hidden; border-color: white;"></th> -->
                              <th :key="data" v-else-if="12 < store_chart.xAxis.categories.length" style="border-right-style: hidden; border-top-style: hidden; border-bottom-style: hidden; border-color: white;"></th>
                            </template>
                          </tr>
                        </table>
                        <br/> 
                      </div>
                    </div>
                    <h4 align="center" v-if="!chart_result">ไม่พบข้อมูลที่ต้องการค้นหา</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
  </div>
</template>
<style scoped>
th.text.highcharts-table-topheading {
  vertical-align: middle
}
.highcharts-data-table tr,
.highcharts-data-table th,
.highcharts-data-table td {
  border: 1px solid silver;
  height: 20px!important;
  min-width: 100px;
  max-width: 100px!important;
}
.highcharts-table-caption {
  display: none;
}
.highcharts-data-table table{
  width: auto;
  margin-left: auto;
  margin-right: auto;
}

.data-table tr,
.data-table th,
.data-table td {
  border: 1px solid silver;
  height: 20px!important;
  min-width: 80px;
  word-break: keep-all;
  white-space: pre;
  text-align: center; 
}

.data-table {
  /* overflow-x: auto; */
}

.data-table table{
  width: auto;
  margin-left: auto;
  margin-right: auto;
  padding-left: inherit;
  padding-right: inherit;
}
</style>
<script>
import { mapState, mapActions } from "vuex";
const moment = require("moment");
import Chart from "chart.js";
import jsPDF from "jspdf";
import { Document, Packer, Paragraph, Media, PageOrientation, AlignmentType, HorizontalPositionAlign, VerticalPositionRelativeFrom, Table, TableCell, TableRow, RelativeHorizontalPosition, WidthType, VerticalAlign, TextRun, BorderStyle } from "docx";
import { saveAs } from "file-saver";
export default {
  data() {
    return {
      defaultDate: "",
      label_position: "top",
      form: {
        type_data: {
          quarter: "",
          year: "",
          monthfrom: "",
          monthto: "",
          month: "",
          quarter_year_from: "",
          quarter_year: "",
          quarterfrom: null,
          quarterto: null,
          yearfrom: "",
          yearto: ""
        },
        listing : [],
        provider_group : [],
        provider_list : [],
        service_rate: 'Mbps',
        service_providers: [],
        promotion_technology: "",
        type_report: "",
        compare_type : "provider",
        forecast : 0,
        weighting : 0,
        average: false,
        service_status : ['S','U','CS','CU']
      },
      pending : false
    };
  },
  computed: {
    ...mapState({
      title_text: store => store.Report_G12.title_text,
      text_service_rate: store => store.Report_G12.text_service_rate,
      store_chart : store => store.Report_G12.chart,
      store_groups : store => store.Report_pmt.provider_group,
      store_providers : store => store.Report_pmt.provider_list,
      chart_result : store => store.Report_G12.chart_result,
      display_chart : store => store.Report_G12.display_chart
    })
  },
  created() {
    var yyy = moment(new Date()).add(0, "y");
    this.defaultDate = yyy;
    this.$store.dispatch('Report_pmt/getGroupCompany','broadband')
    this.$store.dispatch('Report_pmt/getProviderByType','broadband')
  },
  watch : {
    store_providers : {
      handler : function(reload, empty) {
        this.form.listing = reload.map(provider => provider.id)
        this.form.provider_list = this.form.listing
      }
    }
  },
  methods: {
    ...mapActions({
      report_month: "Report_G12/report_month",
      report_year: "Report_G12/report_year",
      report_between_year: "Report_G12/report_between_year",
      report_quarter: "Report_G12/report_quarter",
      report_between_quarter: "Report_G12/report_between_quarter",
      report_between_month: "Report_G12/report_between_month",
      set_report_data : "Report_G12/set_report_data",
      set_chart : "Report_G12/generate"

    }),
    clear_data() {
      this.form.type_data = {
        monthfrom: "",
        monthto: "",
        quarter: "",
        quarter_year: "",
        year: "",
        month: "",
        quarterfrom: [],
        quarterto: [],
        yearfrom: "",
        yearto: ""
      };
    },
    find_chart() {
      if (this.form.type_report === "") {
        this.$alert("กรุณาเลือกประเภทรายงาน", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            this.$refs.type_report.focus();
          }
        });
      } else if (
        this.form.type_report === "month" &&
        this.form.type_data.month === ""
      ) {
        this.$alert("กรุณาเลือกช่วงเวลา", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            this.$refs.month.focus();
          }
        });
      } else if (
        this.form.type_report === "between_month" &&
        (this.form.type_data.monthfrom === "" ||
          this.form.type_data.monthto === "")
      ) {
        this.$alert("กรุณาเลือกช่วงเวลา", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            if (this.form.type_data.monthfrom.length == 0) {
              this.$refs.monthfrom.focus();
            } else {
              this.$refs.monthto.focus();
            }
          }
        });
      } else if (
        this.form.type_report === "year" &&
        this.form.type_data.year === ""
      ) {
        this.$alert("กรุณาเลือกช่วงเวลา", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            this.$refs.year.focus();
          }
        });
      } else if (
        this.form.type_report === "between_year" &&
        (this.form.type_data.yearfrom.length === 0 ||
          this.form.type_data.yearto.length === 0)
      ) {
        this.$alert("กรุณาเลือกช่วงเวลา", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            if (this.form.type_data.yearfrom.length == 0) {
              this.$refs.yearfrom.focus();
            } else {
              this.$refs.yearto.focus();
            }
          }
        });
      } else if (
        this.form.type_report === "quarter" &&
        (this.form.type_data.quarter === "" ||
          this.form.type_data.quarter_year.length === 0)
      ) {
        this.$alert("กรุณาเลือกช่วงเวลา", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            this.$refs.quarter.focus();
            if (this.form.type_data.quarter.length == 0) {
              this.$refs.quarter.focus();
            } else {
              this.$refs.quarter_year.focus();
            }
          }
        });
      } else if (
        this.form.type_report === "between_quarter" &&
        (this.form.type_data.quarterfrom.length === 0 ||
          this.form.type_data.quarterto.length === 0 ||
          this.form.type_data.quarter_year === "")
      ) {
        this.$alert("กรุณาเลือกช่วงเวลา", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            if (this.form.type_data.quarterfrom.length === 0) {
              this.$refs.quarterfrom.focus();
            } else if (this.form.type_data.quarterto.length === 0) {
              this.$refs.quarterto.focus();
            } else {
              this.$refs.quarter_year.focus();
            }
          }
        });
      }else if (!this.form.listing.length){ 
        if(this.form.compare_type == 'group'){
          this.$alert("กรุณาเลือกกลุ่มผู้ให้บริการ", "แจ้งเตือน", {
            confirmButtonText: "ตกลง"
          });
        }else{
          this.$alert("กรุณาเลือกรายชื่อผู้ให้บริการ", "แจ้งเตือน", {
            confirmButtonText: "ตกลง"
          });
        }
        
      }else {
        // let tableDiv = document.querySelectorAll('.highcharts-data-table');
        //   if (tableDiv.length > 0) {
        //     for(let i = 0; i < tableDiv.length; i++) {
        //       tableDiv[i].innerHTML = ''
        //     }
            
        //   }
        if(this.form.compare_type == 'group'){
          this.form.service_providers = this.store_groups.filter(item => this.form.provider_group.includes(item.id))
        }else if (this.form.compare_type == 'provider'){
          this.form.service_providers = this.store_providers.filter(item => this.form.listing.includes(item.id))
        }
        if (this.form.type_report === "between_month") {
          this.report_between_month(this.form);
        }else if (this.form.type_report === "year") {
          this.report_year(this.form);
        }else if (this.form.type_report === "between_year") {
          this.report_between_year(this.form);
        }else if (this.form.type_report === "quarter") {
          this.report_quarter(this.form);
        }else if (this.form.type_report === "between_quarter") {
          let start = moment(this.form.type_data.quarter_year_from).add((this.form.type_data.quarterfrom-1)*3,'M')._d
          let end = moment(this.form.type_data.quarter_year).add((this.form.type_data.quarterto-1)*3+3,'M')
              end = moment(end).subtract(1,'seconds')._d
          if (end <= start) {
            this.$alert("ช่วงไตรมาสเริ่มต้น ต้องน้อยกว่า ช่วงไตรมาสที่สิ้นสุด", "แจ้งเตือน", {
              confirmButtonText: "ตกลง"
            });
          } else {
            let filter = this.form
                filter.daterange = {
                  start : start,
                  end : end
                }
            this.report_between_quarter(filter);
          }
        }
      }
    },
    compareType(){
        this.form.provider_list = []
        this.form.provider_group = []
        this.form.listing = []
    },
    pickGroup(e){
      let obj = JSON.parse(e)
      let arr = typeof(obj) == 'number' ? [obj] :obj
      for(let num of arr){
        if(this.form.listing.includes(num)){
          this.form.listing = this.form.listing.filter(item => item !== num)
        }else{
          this.form.listing.push(num)
        }
      }
    },
    async exportDoc(){
      this.pending = true
      let img_list = []
      let img_prop = []
      let chart_list = document.querySelectorAll('.chart');
      for(let i = 0; i < chart_list.length; i++) {
        await this.$html2canvas(chart_list[i], { canvas : null }).then((canvas)=>{ console.log(canvas)})
        await this.$html2canvas(chart_list[i], { canvas: null, onclone: function(clone) {
            clone.querySelector('.highcharts-root').style.width = '100%';
            clone.querySelector('.highcharts-root').style.height = 'auto';
            clone.querySelector('.highcharts-root').style.objectFit = 'cover';
          } }).then(function(canvas) {
          const img = canvas.toDataURL("image/png", 1.0);
          img_list.push(img)
          img_prop.push(canvas.width/canvas.height)
        });
      }
      let orientation = 0
      await this.$html2canvas(this.$refs.chart, { canvas: null }).then(function(canvas) {
        orientation = canvas.width/canvas.height
      });
      const doc = new Document();
      let rows = []
      let size = orientation > 1 ? 920 : 560
      const image = Media.addImage(doc, img_list[0], size, size/img_prop[0],{});
      let table = [new Paragraph({children: [image], alignment: AlignmentType.CENTER})]
      for(let table_count = 0; table_count < Math.ceil(this.store_chart.xAxis.categories.length/12); table_count++) {
        let temp_cell = []
        temp_cell.push(
          new TableCell({
            width: {size: 100/(13), type: WidthType.PERCENTAGE},
            verticalAlign: VerticalAlign.CENTER,
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: 'ช่วงเวลา',
                    size: 14
                  })
                ],
                alignment: AlignmentType.CENTER
              })
            ] 
          })
        )
        let max_cell = ((table_count+1)*12) > this.store_chart.xAxis.categories.length ? this.store_chart.xAxis.categories.length - ((table_count)*12) : 12
        for(let cell_count = 0; cell_count < 12; cell_count++) {
          if(cell_count < max_cell) {
            temp_cell.push(
              new TableCell({
                width: {size: 100/(13), type: WidthType.PERCENTAGE},
                verticalAlign: VerticalAlign.CENTER,
                children: [
                  new Paragraph({
                    children: [
                      new TextRun({
                        text: this.store_chart.xAxis.categories[(table_count*12)+cell_count],
                        size: 14
                      })
                    ],
                    alignment: AlignmentType.CENTER
                  })
                ] 
              })
            )
          }
        }
        let temp_row = [new TableRow({
          children: temp_cell
        })]
        for(let provider of this.store_chart.series) {
          temp_cell = []
          temp_cell.push(
            new TableCell({
              verticalAlign: VerticalAlign.CENTER,
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: provider.name,
                      size: 14
                    })
                  ],
                  alignment: AlignmentType.CENTER
                })
              ] 
            })
          )
          for(let cell_count = 0; cell_count < 12; cell_count++) {
            if(cell_count < max_cell) {
              temp_cell.push(
                new TableCell({
                  verticalAlign: VerticalAlign.CENTER,
                  children: [
                    new Paragraph({
                      children: [
                        new TextRun({
                          text: provider.data[(table_count*12)+cell_count] > 0 ? this.roundToTwo(provider.data[(table_count*12)+cell_count], this.store_chart.decimal).toFixed(this.store_chart.decimal) : '',
                          size: 14
                        })
                      ],
                      alignment: AlignmentType.CENTER
                    })
                  ] 
                })
              )
            }
          }
          temp_row.push(
            new TableRow({
              children: temp_cell
            })
          )
        }
        table.push(new Table({alignment: AlignmentType.CENTER, rows: temp_row, width: {size: temp_cell.length*(100/13), type: WidthType.PERCENTAGE}}))
        table.push(new Paragraph(''))
      }
      // const table = new Table({rows: rows});
      doc.addSection({
        size: {
          orientation: orientation > 1 ? PageOrientation.LANDSCAPE : PageOrientation.PORTRAIT,
        },
        children: table
      });
      Packer.toBlob(doc).then(blob => {
        saveAs(blob, "Report_m12.doc");
        this.pending = false
      });
    },
    async exportPDF() {
      this.pending = true
      await this.$html2canvas(this.$refs.chart, { canvas: null}).then(function(canvas){
        console.log(canvas)
      })
      await this.$html2canvas(this.$refs.chart, { canvas: null, onclone: function(clone) {
            clone.querySelector('.highcharts-root').style.width = '100%';
            clone.querySelector('.highcharts-root').style.height = 'auto';
            clone.querySelector('.highcharts-root').style.objectFit = 'cover';
          } 
      }).then((canvas)=>{
        const img = canvas.toDataURL("image/png", 1.0);
        if (canvas.height > canvas.width) {
          var dox = new jsPDF("p","pt",[canvas.width, canvas.height]);
        } else {
          var dox = new jsPDF("l","pt",[canvas.width, canvas.height]);
        }
        dox.addImage(img, 'PNG', 0, 5, canvas.width, canvas.height);
        dox.save("Report_m12.pdf")
        this.pending = false
      });
    },
    exportImage() {
      this.$html2canvas(this.$refs.chart, { canvas: null, onclone: function(clone) {
            clone.querySelector('.highcharts-root').style.width = '100%';
            clone.querySelector('.highcharts-root').style.height = 'auto';
            clone.querySelector('.highcharts-root').style.objectFit = 'cover';
          } }).then(function(canvas) {
        const img = canvas.toDataURL("image/png", 1.0);
        if (canvas.height > canvas.width) {
          var dox = new jsPDF("p","pt",[canvas.width, canvas.height]);
        } else {
          var dox = new jsPDF("l","pt",[canvas.width, canvas.height]);
        }
        dox.addImage(img, 'PNG', 0, 5, canvas.width, canvas.height);
        saveAs(img, "Report_m12.png")
      });
    },
    exportFile(com) {
      if(com == 'doc') {
        this.exportDoc()
      } else if (com == 'pdf') {
        this.exportPDF()
      } else if (com == 'image') {
        this.exportImage()
      }
    },
    roundToTwo(num, point) {    
      return +(Math.round(num + "e+" + point)  + "e-" + point);
    }
  }
};
</script>
